import styles from "../Startup/Choose.module.css";
import { Logo, useState, useEffect, ToastContainer, BiCheck, RiDragMove2Line, BiRightArrowAlt, FaEye } from '../../common/common'
import useNavigation from "../../common/useNavigation";
import ExcelUpload from "./ExcelUpload";
import Button from 'react-bootstrap/Button';
import useGetUserData from '../../secureAPI/GetUserData';


const BulkUploadProduct = () => {
    const { users, } = useGetUserData();
    const { navigateDashboard } = useNavigation();
    const [usertype, setUserType] = useState(0);


    useEffect(() => {
        //  console.log('called useeffectsss');
        if (Array.isArray(users) && users.length > 0) {
            //   console.log('useEffect called, users:', users);
            logUserData();
        }
    }, [users]);
    const logUserData = () => {
        // console.log({users:users});

        if (users?.length > 0) {
            // console.log(users[0]['UserType']);
            setUserType(users[0]['UserType']);
        }
    };


    // const navigationDashboard = () =>
    // {
    //     if(usertype === '1,2')
    //     {
    //         navigateDashboard();
    //     }
    //     else if(usertype === '1')
    //     {
    //         const { navigateBuyerDashboard } = useNavigation();
    //     }
    // }
    const onFileChange = (files) => {
        // console.log(files)
    }


    return (
        <div>
            <div className={`${styles.personalDetails} ` + " hidden  lg:block lg:w-[30%]  fixed h-screen overflow-y-auto scrollbar-hide "} >
                <div className="h-[100px]">
                    <div className="flex flex-row justify-center">
                        <img className="mr-0" src={Logo} width={160} height={70} alt="Dasahboard" />
                    </div>
                </div>
                <div className="mt-32">
                    <div className='relative mx-10 border-[1px] border-[#e5e5e533] border-solid rounded-xl bg-[#003d79]'>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#07ff5a] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12">

                                    <span className="text-xl sm:text-2xl px-2">
                                        <BiCheck className="text-2xl" />
                                    </span>
                                </div>
                                {/* Text Content */}
                                <div className="px-5 sm:ml-5 w-full sm:w-auto opacity-60  rounded-md py-1">
                                    <h1 className="text-xl font-semibold text-white">
                                        Seller Profile Configuration
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        To establish your seller profile, please complete the designated form. You may create multiple seller profiles under the same Selzor account; however, a separate plan is required for each seller profile.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#07ff5a] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12">

                                    <span className="text-xl sm:text-2xl px-2">
                                        <BiCheck className="text-2xl" />
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-5 sm:ml-5 w-full sm:w-auto opacity-60  rounded-md py-1">
                                    <h1 className="text-xl font-semibold text-white">
                                        {" "} Product Attributes {" "}
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        {" "}Select mandatory attributes (code, name, category) and choose which to display to customers while adding product data{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#07ff5a] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12">

                                    <span className="text-xl sm:text-2xl px-2">
                                        <BiCheck className="text-2xl" />
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-5 sm:ml-5 w-full sm:w-auto ">
                                    <h1 className="text-xl font-semibold text-white">
                                        {" "} Reorder Attributes {" "}
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        {" "}Streamline product attributes to enhance clarity and facilitate informed decision-making{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className={`${styles.animationPulse} bg-[#ffc107] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 sm:w-12 sm:h-12`}>

                                    <span className="text-xl sm:text-2xl px-2">
                                        4
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-5 sm:ml-5 w-full sm:w-auto ">
                                    <h1 className="text-xl font-semibold text-white">
                                        {" "}Import Product Excelsheet{" "}
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        {" "}Easily import product information using the Excel spreadsheet to manage your inventory better{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className=" h-screen grid grid-cols-1 lg:col-span-12 lg:ml-[30%]">
                {/* <div className="text-center text-blue-700">
        <div className="max-w-[400px] w-full my-2 mx-auto p-2 flex flex-row">
            <img src={Logo} width={160} height={70} alt="Logo" />
        </div>
    </div> */}
                <div className="w-full h-full bg-white pb-2 pt-2">
                    <div className="mx-2 border-2 border-solid border-gray-200 bg-white p-5 rounded-md mb-16 h-full">
                        <div className="flex flex-row">
                            <div className="px-1">
                                <h1 className="text-lg text-theme-color-text font-bold">Product Attributes</h1>
                                <p className="text-gray-600 text-md font-medium">
                                    select attributes as per your products range, code, name and category are required attributes.
                                    you have to an option to include all attributes while adding product data but displaying only
                                    few of them to your buyers.
                                </p>
                            </div>
                        </div>

                        <div className="py-5">
                            <ExcelUpload onFileChange={(files) => onFileChange(files)} />
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </div>
    )
}

export default BulkUploadProduct